var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0507812,
    width: 34.2921,
    height: 34.2921,
    rx: 17.1461,
    fill: "#007E99"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4165_7591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9861 23.0394H20.5289V19.1891C20.5289 18.2709 20.5103 17.0894 19.2485 17.0894C17.9675 17.0894 17.7718 18.0885 17.7718 19.1213V23.0394H15.3146V15.1218H17.675V16.201H17.7068C18.0366 15.5787 18.8386 14.922 20.0367 14.922C22.5264 14.922 22.9868 16.5606 22.9868 18.6934L22.9861 23.0394ZM12.5395 14.0384C11.7485 14.0384 11.1132 13.3982 11.1132 12.6107C11.1132 11.8239 11.7492 11.1844 12.5395 11.1844C13.3276 11.1844 13.9665 11.8239 13.9665 12.6107C13.9665 13.3982 13.3269 14.0384 12.5395 14.0384ZM13.7715 23.0394H11.3074V15.1218H13.7715V23.0394ZM24.2154 8.89941H10.074C9.39718 8.89941 8.84961 9.43454 8.84961 10.0948V24.297C8.84961 24.9579 9.39718 25.4924 10.074 25.4924H24.2133C24.8895 25.4924 25.4426 24.9579 25.4426 24.297V10.0948C25.4426 9.43454 24.8895 8.89941 24.2133 8.89941H24.2154Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4165_7591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6992,
    height: 17.6992,
    fill: "white",
    transform: "translate(8.29688 8.34668)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.5609ed8bbcd30b9e19fc55b9e44bf331.svg";
export { ForwardRef as ReactComponent };